import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "LeadAirDataSheet/";

const getLeadAirDataSheetById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetLeadAirDataSheetById?jobFormId=' + id, constants.REQUIRE_INTERCEPTORS);

const start = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'Start', model, constants.REQUIRE_INTERCEPTORS);

const save = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'Save', model, constants.REQUIRE_INTERCEPTORS);

const saveLineItem = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveLineItem', model, constants.REQUIRE_INTERCEPTORS);

const deleteLineItem = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteLineItem?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getReportPdf = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetReportPdf?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getUsersFromLeadInfoSheet = async (jobId, projectId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetUsersListFromLeadInfoSheet?jobId=' + jobId + "&projectId=" + projectId, constants.REQUIRE_INTERCEPTORS);

export {
    getLeadAirDataSheetById,
    start,
    save,
    saveLineItem,
    deleteLineItem,
    getReportPdf,
    getUsersFromLeadInfoSheet
}